import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { AbstractApproval } from './abstract-approval';
import { Person } from './person';
import { User } from './user';

@inheritSerialization(AbstractApproval)
// TODO: May want to delete this?
export class ApprovalStatus extends AbstractApproval {
  @autoserialize
  object: string;

  @autoserialize
  status: string;

  @autoserializeAs(Person)
  requester: Person;

  @autoserializeAs(User)
  reviewers: Array<User>;
}
